import Links from '@/shared/constants/navegacao';
import MyContext from '@/shared/contexts/AppContext';
import { CarregarPermissoes, ValidarPermissao, getLoginTokenFromStorage, } from '@/modules/system/auth/application/auth.service';
import { ModuloSistema } from '../constants/modulos-sistema.enum';
import { Navigate, useNavigate } from 'react-router-dom';
import { RoleLevelDto } from '@/modules/system/papeis/role-level.dto';
import { useContext, useEffect, useMemo, useState } from 'react';

interface ProtectedRouteProps {
  children: JSX.Element;
  allowed: ModuloSistema[];
  /** Uma permissão exigida ou lista de permissões (qualquer uma satisfaz). */
  permissao?: RoleLevelDto | RoleLevelDto[];
}

/**
 * Define que uma rota é protegida.
 * @param {route} children
 * @returns
 */
export default function Protected({
  children,
  allowed,
  permissao,
}: ProtectedRouteProps) {
  const navigate = useNavigate();
  const context = useContext(MyContext);

  if (!context)
    throw new Error('DisplayComponent deve ser usado dentro de um MyProvider');
  const { state } = context;

  const TOKEN = getLoginTokenFromStorage();
  const [isNotLoggedIn] = useState(TOKEN === null || TOKEN === undefined);

  if (allowed && allowed.length > 0 && !allowed.includes(state.modulo!))
    return <Navigate to="/nao-autorizado" replace />;

  const permissoes = useMemo(() => CarregarPermissoes(), []);
  if (permissao) {
    const exigidas = Array.isArray(permissao) ? permissao : [permissao];
    const temAlguma = exigidas.some((p) => ValidarPermissao(permissoes, [p]));
    if (!temAlguma) {
      return <Navigate to="/nao-existe" replace />;
    }
  }

  useEffect(() => {
    if (isNotLoggedIn || !state) navigate(`${Links.Auth_Login}`);

    if (!state.modulo) {
      navigate(`${Links.Escolha_Modulo}`);
    }
  }, []);

  if (!isNotLoggedIn) {
    return children;
  }
}
